// extracted by mini-css-extract-plugin
module.exports = {"root":"TileSelector-root-ecd505f261967db51660ef0dd9941e26"};